import React, { useState, useEffect, useMemo } from 'react';
import { Table, ConfigProvider, theme, Dropdown, Modal, Input, DatePicker, Select, Checkbox, Button } from 'antd';
import {
    Menu, Tag, Download, Upload, Settings, ChevronDown, ChevronRight,
    SlidersHorizontal, LayoutTemplate, PlusSquare,
    XCircle, AlertCircle, Wrench, CheckCircle, ArrowDown, ArrowUp,
    QrCode, Link2, Edit, FileText, Copy, Trash2, UploadCloud, Plus
} from 'lucide-react';
import Layout from '../../Layout';
import { Link, useNavigate } from 'react-router-dom';

const { TextArea } = Input;
const THEME_COLOR = '#3e91ab';

// ================= COMPONENT: INPUT CÓ LABEL ĐÈ LÊN VIỀN =================
const FloatingLabelWrapper = ({ label, children, required, bgClass = 'bg-white' }) => (
    <div className="relative mt-3 min-w-0 w-full">
        {label && (
            <label className={`absolute -top-2.5 left-3 ${bgClass} dark:bg-gray-800 px-1 text-[11px] text-gray-500 dark:text-gray-400 z-10 flex items-center gap-1 whitespace-nowrap`}>
                {label} {required && <span className="text-red-500">*</span>}
            </label>
        )}
        {children}
    </div>
);

// ================= 1. DỮ LIỆU MẪU DẠNG PHẲNG =================
const flatData = [
    { id: '9', name: 'Bộ phím chuột Logitech K235', category: 'Bộ phím chuột', type: 'Bộ phím chuột', date: '11/01/2022', qty: 1, used: 0, remain: 0, price: '450,000', status: 'broken', user: null, dept: '--' },
    { id: '895', name: 'Samsung Galaxy A54 5G + Ốp + Củ cáp sạc', tag: 'Còn tốt', category: 'Điện thoại', type: 'Điện thoại', date: '16/10/2023', qty: 1, used: 0, remain: 0, price: '10,333,000', status: 'broken', user: null, dept: '--' },
    { id: '894', name: 'Samsung Galaxy A34 5G + Ốp + Củ cáp sạc', category: 'Điện thoại', type: 'Điện thoại', date: '16/10/2023', qty: 1, used: 0, remain: 0, price: '8,048,300', status: 'broken', user: null, dept: '--' },
    { id: 'TS.142', name: 'NTL Test', category: 'Macbook', type: 'Macbook', date: '10/06/2025', qty: 1, used: 31, remain: '1,967', price: '3,994,002', status: 'broken', user: { name: 'Nguyễn Tuấn Linh', more: '+1' }, dept: 'CÔNG TY TNHH Nguyễn Tuấn Linh, CÔNG TY CỔ PHẦN 1OFFICE (1006)' },
    { id: '838', name: 'MacBook Pro 13inch (M2/16GB/512GB)', category: 'Macbook', type: 'Macbook', date: '03/10/2023', qty: 2, used: 1, remain: 4, price: '198,935,000', status: 'broken', user: { name: 'Nguyễn Tú Anh' }, dept: 'CÔNG TY CỔ PHẦN 1OFFICE (1006)' },
    { id: 'TS.135', name: 'MÀN HÌNH DELL', category: 'Màn hình', type: 'Màn hình', date: '02/05/2025', qty: 1, used: 4, remain: 4, price: '24,000,000', status: 'broken', user: { name: 'Trần Phạm Huyền Trâm', more: '+1' }, dept: 'Ban Giám Đốc, CÔNG TY CỔ PHẦN 1OFFICE' },
    { id: 'TS.128', name: 'Màn hình LG 27"', category: 'Màn hình', type: 'Màn hình', date: '01/04/2025', qty: 2, used: 15, remain: 78, price: '279,000,000', status: 'broken', user: { name: 'Trần Phạm Huyền Trâm', more: '+1' }, dept: 'CÔNG TY CỔ PHẦN 1OFFICE' },
    { id: '897', name: 'Màn hình Philips 27" 276B1', category: 'Màn hình', type: 'Màn hình', date: '06/10/2023', qty: 1, used: 0, remain: 0, price: '7,690,000', status: 'broken', user: null, dept: '--' },
    { id: '875', name: 'Hub Baseus 9in1', category: 'HUB', type: 'HUB', date: '13/10/2023', qty: 1, used: 0, remain: 1, price: '880,000', status: 'broken', user: null, dept: '--' },
];

const TAB_CONFIGS = [
    { key: 'all', label: 'Tất cả' },
    { key: 'unallocated', label: 'Chưa cấp phát' },
    { key: 'in_use', label: 'Đang sử dụng' },
    { key: 'liquidated', label: 'Thanh lý' },
    { key: 'maintenance', label: 'Bảo trì, sửa chữa' },
    { key: 'lost', label: 'Mất' },
    { key: 'destroyed', label: 'Hủy' },
    { key: 'broken', label: 'Hỏng' },
];

// ================= CẤU HÌNH MENU CHUỘT PHẢI =================
const contextMenuItems = [
    { key: 'cap_phat', icon: <Upload size={16} className="text-gray-500" />, label: 'Cấp phát' },
    { key: 'thu_hoi', icon: <Download size={16} className="text-gray-500" />, label: 'Thu hồi' },
    { key: 'bao_huy', icon: <XCircle size={16} className="text-gray-500" />, label: 'Báo hủy' },
    { key: 'bao_hong', icon: <AlertCircle size={16} className="text-gray-500" />, label: 'Báo hỏng' },
    { key: 'bao_tri', icon: <Wrench size={16} className="text-gray-500" />, label: 'Bảo trì, sửa chữa' },
    { key: 'da_thanh_ly', icon: <CheckCircle size={16} className="text-gray-500" />, label: 'Đã thanh lý' },
    { key: 'bao_mat', icon: <ArrowDown size={16} className="text-gray-500" />, label: 'Báo mất' },
    { key: 'bao_tang', icon: <ArrowUp size={16} className="text-gray-500" />, label: 'Báo tăng' },
    { type: 'divider' },
    { key: 'in_qrcode', icon: <QrCode size={16} className="text-gray-500" />, label: 'In Qrcode' },
    { type: 'divider' },
    { key: 'lien_ket', icon: <Link2 size={16} className="text-gray-500" />, label: 'Liên kết đối tượng liên quan' },
    { key: 'tao_moi_lk', icon: <PlusSquare size={16} className="text-gray-500" />, label: 'Tạo mới đối tượng liên quan', children: [{ key: 'tao_1', label: 'Hợp đồng' }] },
    { type: 'divider' },
    { key: 'them_tai_lieu', icon: <UploadCloud size={16} className="text-gray-500" />, label: 'Thêm tài liệu', children: [{ key: 'tl_1', label: 'Từ máy tính' }] },
    { key: 'bieu_mau', icon: <FileText size={16} className="text-gray-500" />, label: 'Biểu mẫu', children: [{ key: 'bm_1', label: 'Mẫu bàn giao' }] },
    { key: 'nhan', icon: <Tag size={16} className="text-gray-500" />, label: 'Nhãn' },
    { type: 'divider' },
    { key: 'sua', icon: <Edit size={16} className="text-gray-500" />, label: 'Sửa' },
    { key: 'xoa', icon: <Trash2 size={16} className="text-gray-500" />, label: 'Xóa' },
    { key: 'chi_tiet', icon: <FileText size={16} className="text-gray-500" />, label: 'Chi tiết', children: [{ key: 'ct_1', label: 'Xem chi tiết' }] },
    { key: 'nhan_ban', icon: <Copy size={16} className="text-gray-500" />, label: 'Nhân bản' },
    { type: 'divider' },
    { key: 'tuy_chinh', icon: <SlidersHorizontal size={16} className="text-gray-500" />, label: 'Tùy chỉnh' },
];

export default function AssetListAntd() {
    const navigate = useNavigate();

    const [isDarkMode, setIsDarkMode] = useState(false);
    const [activeTab, setActiveTab] = useState('broken');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    const [popup, setPopup] = useState({ visible: false, x: 0, record: null });

    // ================= STATES QUẢN LÝ MODAL (POPUP) =================
    const [modals, setModals] = useState({
        lost: false,
        destroy: false,
        broken: false,
        maintenance: false,
        liquidate: false,
        allocate: false,
        recall: false,
        qr: false
    });

    const openModal = (type) => setModals(prev => ({ ...prev, [type]: true }));
    const closeModal = (type) => setModals(prev => ({ ...prev, [type]: false }));

    const handleMenuClick = (key) => {
        setPopup({ ...popup, visible: false });
        if (key === 'bao_mat') openModal('lost');
        if (key === 'bao_huy') openModal('destroy');
        if (key === 'bao_hong') openModal('broken');
        if (key === 'bao_tri') openModal('maintenance');
        if (key === 'da_thanh_ly') openModal('liquidate');
        if (key === 'cap_phat') openModal('allocate');
        if (key === 'thu_hoi') openModal('recall');
        if (key === 'in_qrcode') openModal('qr');
    };

    const tabCounts = useMemo(() => {
        const counts = { all: flatData.length };
        TAB_CONFIGS.slice(1).forEach(tab => {
            counts[tab.key] = flatData.filter(item => item.status === tab.key).length;
        });
        return counts;
    }, []);

    const filteredData = useMemo(() => {
        if (activeTab === 'all') return flatData;
        return flatData.filter(item => item.status === activeTab);
    }, [activeTab]);

    const treeData = useMemo(() => {
        const grouped = {};
        filteredData.forEach(item => {
            if (!grouped[item.category]) grouped[item.category] = [];
            grouped[item.category].push({ ...item, key: item.id });
        });

        return Object.keys(grouped).map(category => ({
            key: `group_${category}`,
            isGroup: true,
            categoryName: category,
            count: grouped[category].length,
            children: grouped[category]
        }));
    }, [filteredData]);

    useEffect(() => {
        const allGroupKeys = treeData.map(group => group.key);
        setExpandedRowKeys(allGroupKeys);
    }, [treeData]);

    const columns = [
        {
            title: 'Mã TS',
            dataIndex: 'id',
            key: 'id',
            width: 150,
            render: (text, record) => {
                if (record.isGroup) {
                    const isExpanded = expandedRowKeys.includes(record.key);
                    return {
                        children: (
                            <div
                                className="text-[#3e91ab] font-medium cursor-pointer flex items-center select-none"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const newKeys = isExpanded
                                        ? expandedRowKeys.filter(k => k !== record.key)
                                        : [...expandedRowKeys, record.key];
                                    setExpandedRowKeys(newKeys);
                                }}
                            >
                                {record.categoryName} ({record.count})
                                {isExpanded ? <ChevronDown size={16} className="ml-1" /> : <ChevronRight size={16} className="ml-1" />}
                            </div>
                        ),
                        props: { colSpan: 10 }
                    };
                }
                return <Link to="/assets/detail" className="text-gray-700 dark:text-gray-200 hover:text-[#3e91ab] dark:hover:text-[#3e91ab] transition-colors">{text}</Link>;
            }
        },
        {
            title: 'Tên tài sản',
            dataIndex: 'name',
            key: 'name',
            width: 250,
            render: (text, record) => {
                if (record.isGroup) return { props: { colSpan: 0 } };
                return (
                    <div>
                        <Link to="/assets/detail" className="text-gray-700 dark:text-gray-200 hover:text-[#3e91ab] dark:hover:text-[#3e91ab] transition-colors">{text}</Link>
                        {record.tag && (
                            <div className="flex items-center gap-1.5 mt-1">
                                <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] bg-blue-50 dark:bg-blue-900/30 text-[#3e91ab] dark:text-[#5cb1cb] border border-blue-100 dark:border-blue-800">
                                    <div className="w-1 h-1 rounded-full bg-[#3e91ab] dark:bg-[#5cb1cb]"></div> {record.tag}
                                </span>
                                <PlusSquare size={12} className="text-gray-400 dark:text-gray-500 cursor-pointer" />
                            </div>
                        )}
                    </div>
                );
            }
        },
        {
            title: 'Loại tài sản',
            dataIndex: 'type',
            key: 'type',
            render: (text, record) => record.isGroup ? { props: { colSpan: 0 } } : <span className="text-gray-600 dark:text-gray-300">{text}</span>
        },
        {
            title: 'Ngày mua',
            dataIndex: 'date',
            key: 'date',
            align: 'center',
            render: (text, record) => record.isGroup ? { props: { colSpan: 0 } } : <span className="text-gray-600 dark:text-gray-300">{text}</span>
        },
        {
            title: activeTab === 'broken' ? 'SL hỏng' : 'Số lượng',
            dataIndex: 'qty',
            key: 'qty',
            align: 'center',
            render: (text, record) => record.isGroup ? { props: { colSpan: 0 } } : <span className="text-gray-600 dark:text-gray-300">{text}</span>
        },
        {
            title: 'Đang sử dụng',
            dataIndex: 'used',
            key: 'used',
            align: 'center',
            render: (text, record) => record.isGroup ? { props: { colSpan: 0 } } : <span className="text-gray-600 dark:text-gray-300">{text}</span>
        },
        {
            title: 'SL còn lại',
            dataIndex: 'remain',
            key: 'remain',
            align: 'center',
            render: (text, record) => record.isGroup ? { props: { colSpan: 0 } } : <span className="text-gray-600 dark:text-gray-300">{text}</span>
        },
        {
            title: 'Nguyên giá',
            dataIndex: 'price',
            key: 'price',
            align: 'right',
            render: (text, record) => record.isGroup ? { props: { colSpan: 0 } } : <span className="text-gray-600 dark:text-gray-300">{text}</span>
        },
        {
            title: 'Nhân sự sử dụng',
            dataIndex: 'user',
            key: 'user',
            render: (user, record) => {
                if (record.isGroup) return { props: { colSpan: 0 } };
                if (!user) return <span className="text-gray-400 dark:text-gray-600">--</span>;
                return (
                    <div className="flex items-center gap-1">
                        <span className="px-2 py-0.5 bg-[#3e91ab]/10 dark:bg-[#3e91ab]/20 text-[#3e91ab] dark:text-[#5cb1cb] border border-[#3e91ab]/20 dark:border-[#3e91ab]/40 rounded-full text-xs whitespace-nowrap">
                            {user.name}
                        </span>
                        {user.more && (
                            <span className="px-1.5 py-0.5 bg-white dark:bg-gray-800 border border-[#3e91ab]/30 dark:border-[#3e91ab]/50 text-[#3e91ab] dark:text-[#5cb1cb] rounded-full text-[10px]">
                                {user.more}
                            </span>
                        )}
                    </div>
                );
            }
        },
        {
            title: 'Phòng ban sử dụng',
            dataIndex: 'dept',
            key: 'dept',
            width: 250,
            render: (text, record) => record.isGroup ? { props: { colSpan: 0 } } : <span className="text-gray-600 dark:text-gray-300 whitespace-normal text-xs">{text}</span>
        },
    ];

    const getRecordName = () => popup.record ? `${popup.record.id} - ${popup.record.name}` : '';

    return (
        <Layout>
            <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-6 shrink-0 gap-4">
                <div>
                    <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Danh sách tài sản</h1>
                </div>
                <button className="flex items-center gap-2 px-3 py-1.5 bg-[#3e91ab] text-white rounded text-sm font-medium hover:bg-[#357f96] transition-colors max-w-[120px]" onClick={() => navigate(`/assets/add`)}>
                    <Plus size={16} /> Thêm mới
                </button>
            </div>

            <div className="bg-white dark:bg-gray-900 min-h-screen relative">

                {/* HEADER - TABS */}
                <div className="flex items-center border-b border-gray-100 dark:border-gray-800 px-4 pt-3 overflow-x-auto no-scrollbar">
                    <button className="mr-6 mb-3 text-gray-400 hover:text-[#3e91ab]">
                        <Menu size={18} />
                    </button>
                    <div className="flex space-x-6 min-w-max">
                        {TAB_CONFIGS.map(tab => (
                            <button
                                key={tab.key}
                                onClick={() => setActiveTab(tab.key)}
                                className={`pb-3 text-[13px] font-medium border-b-2 whitespace-nowrap transition-colors ${activeTab === tab.key
                                    ? 'border-[#3e91ab] text-[#3e91ab]'
                                    : 'border-transparent text-gray-500 hover:text-000000e0 dark:text-gray-400 dark:hover:text-gray-200'
                                    }`}
                            >
                                {tab.label} ({tabCounts[tab.key]})
                            </button>
                        ))}
                    </div>
                </div>

                {/* TOOLBAR */}
                <div className="flex justify-between items-center px-4 py-3 bg-white dark:bg-gray-900 border-b border-gray-100 dark:border-gray-800 overflow-x-auto no-scrollbar">
                    <div className="flex items-center gap-3 shrink-0 min-w-max">
                        <SlidersHorizontal size={14} className="text-gray-400 cursor-pointer hover:text-[#3e91ab]" />
                        <LayoutTemplate size={14} className="text-gray-400 cursor-pointer hover:text-[#3e91ab]" />
                        <div className="w-px h-4 bg-gray-200 dark:bg-gray-700"></div>
                        <span className="text-[13px] text-gray-500 dark:text-gray-400">
                            Hiển thị 1 - {filteredData.length} / {filteredData.length} bản ghi
                        </span>
                    </div>

                    <div className="flex items-center space-x-4 shrink-0 min-w-max ml-4">
                        <button className="flex items-center text-[12px] font-medium text-gray-600 dark:text-gray-300 hover:text-[#3e91ab] dark:hover:text-[#3e91ab] transition-colors">
                            <Tag size={14} className="mr-1.5 text-gray-400" /> Nhãn
                        </button>
                        <button className="flex items-center text-[12px] font-medium text-gray-600 dark:text-gray-300 hover:text-[#3e91ab] dark:hover:text-[#3e91ab] transition-colors">
                            <Download size={14} className="mr-1.5 text-gray-400" /> Export
                        </button>
                        <button className="flex items-center text-[12px] font-medium text-gray-600 dark:text-gray-300 hover:text-[#3e91ab] dark:hover:text-[#3e91ab] transition-colors">
                            <Upload size={14} className="mr-1.5 text-gray-400" /> Import
                        </button>
                        <button className="flex items-center text-[12px] font-medium text-gray-600 dark:text-gray-300 hover:text-[#3e91ab] dark:hover:text-[#3e91ab] transition-colors" onClick={() => navigate(`/assets/setup`)}>
                            <Settings size={14} className="mr-1.5 text-gray-400" /> Cài đặt
                        </button>
                    </div>
                </div>

                {/* BẢNG DỮ LIỆU */}
                <div className="pb-10">
                    <ConfigProvider
                        theme={{
                            algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
                            components: {
                                Table: {
                                    headerBg: isDarkMode ? '#1f2937' : '#ffffff',
                                    headerColor: isDarkMode ? '#9ca3af' : '#6b7280',
                                    cellPaddingBlock: 12,
                                    rowHoverBg: isDarkMode ? '#374151' : '#f9fafb',
                                    borderColor: isDarkMode ? '#374151' : '#f3f4f6'
                                },
                            },
                        }}
                    >
                        <Table
                            rowSelection={{
                                selectedRowKeys,
                                onChange: setSelectedRowKeys,
                            }}
                            columns={columns}
                            dataSource={treeData}
                            pagination={false}
                            scroll={{ x: 'max-content' }}
                            onRow={(record) => {
                                return {
                                    onContextMenu: (e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (!record.isGroup) {
                                            setPopup({ visible: true, x: e.clientX, record });
                                        }
                                    }
                                };
                            }}
                            rowClassName={(record) => record.isGroup ? 'bg-gray-50/50 dark:bg-gray-800/80' : 'bg-transparent text-[13px] hover:bg-gray-50 dark:hover:bg-gray-800 cursor-context-menu'}
                            expandable={{
                                expandedRowKeys,
                                onExpand: (_, record) => {
                                    const key = record.key;
                                    setExpandedRowKeys(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
                                },
                                expandIcon: () => null,
                            }}
                        />
                    </ConfigProvider>
                </div>

                {/* ================= COMPONENT DROPDOWN CHUỘT PHẢI ================= */}
                <Dropdown
                    menu={{
                        items: contextMenuItems,
                        onClick: (e) => handleMenuClick(e.key),
                        style: {
                            maxHeight: 'calc(100vh - 80px)',
                            overflowY: 'auto',
                            width: 260
                        }
                    }}
                    open={popup.visible}
                    onOpenChange={(open) => {
                        if (!open) setPopup({ ...popup, visible: false });
                    }}
                    trigger={['click']}
                    placement="bottomLeft"
                    overlayClassName="custom-context-menu text-000000e0"
                >
                    <div style={{
                        position: 'fixed',
                        left: popup.x,
                        top: 40,
                        width: 1,
                        height: 1,
                        pointerEvents: 'none',
                        zIndex: 9999
                    }} />
                </Dropdown>

                {/* ================= MODALS (POPUPS) ================= */}
                
                {/* 1. Phiếu báo mất */}
                <Modal title={<span className="font-bold text-000000e0">Phiếu báo mất</span>} open={modals.lost} onCancel={() => closeModal('lost')} footer={[<Button key="back" onClick={() => closeModal('lost')}>HỦY BỎ</Button>, <Button key="submit" type="primary" style={{ backgroundColor: THEME_COLOR }}>CẬP NHẬT</Button>]}>
                    <div className="flex flex-col gap-4 py-2">
                        <FloatingLabelWrapper label="Tài sản" required><Input disabled value={getRecordName()} className="bg-gray-50" /></FloatingLabelWrapper>
                        <div className="grid grid-cols-2 gap-4">
                            <FloatingLabelWrapper label="Ngày báo" required><DatePicker className="w-full" format="DD/MM/YYYY" /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Số lượng" required><Input /></FloatingLabelWrapper>
                        </div>
                        <FloatingLabelWrapper label="Mô tả"><TextArea rows={3} placeholder="Nhập mô tả" /></FloatingLabelWrapper>
                    </div>
                </Modal>

                {/* 2. Phiếu báo hủy */}
                <Modal title={<span className="font-bold text-000000e0">Phiếu báo hủy</span>} open={modals.destroy} onCancel={() => closeModal('destroy')} footer={[<Button key="back" onClick={() => closeModal('destroy')}>HỦY BỎ</Button>, <Button key="submit" type="primary" style={{ backgroundColor: THEME_COLOR }}>CẬP NHẬT</Button>]}>
                    <div className="flex flex-col gap-4 py-2">
                        <FloatingLabelWrapper label="Tài sản" required><Input disabled value={getRecordName()} className="bg-gray-50" /></FloatingLabelWrapper>
                        <div className="grid grid-cols-2 gap-4">
                            <FloatingLabelWrapper label="Ngày báo" required><DatePicker className="w-full" format="DD/MM/YYYY" /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Số lượng" required><Input /></FloatingLabelWrapper>
                        </div>
                        <FloatingLabelWrapper label="Mô tả"><TextArea rows={3} placeholder="Nhập mô tả" /></FloatingLabelWrapper>
                    </div>
                </Modal>

                {/* 3. Phiếu báo hỏng */}
                <Modal title={<span className="font-bold text-000000e0">Phiếu báo hỏng</span>} open={modals.broken} onCancel={() => closeModal('broken')} footer={[<Button key="back" onClick={() => closeModal('broken')}>HỦY BỎ</Button>, <Button key="submit" type="primary" style={{ backgroundColor: THEME_COLOR }}>CẬP NHẬT</Button>]}>
                    <div className="flex flex-col gap-4 py-2">
                        <FloatingLabelWrapper label="Tài sản" required><Input disabled value={getRecordName()} className="bg-gray-50" /></FloatingLabelWrapper>
                        <div className="grid grid-cols-3 gap-4">
                            <FloatingLabelWrapper label="Ngày báo" required><DatePicker className="w-full" format="DD/MM/YYYY" /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Số lượng" required><Input /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Giá trị"><Input /></FloatingLabelWrapper>
                        </div>
                        <FloatingLabelWrapper label="Mô tả"><TextArea rows={3} placeholder="Nhập mô tả" /></FloatingLabelWrapper>
                    </div>
                </Modal>

                {/* 4. Phiếu bảo hành, sửa chữa */}
                <Modal title={<span className="font-bold text-000000e0">Phiếu bảo hành, sửa chữa</span>} open={modals.maintenance} onCancel={() => closeModal('maintenance')} footer={[<Button key="back" onClick={() => closeModal('maintenance')}>HỦY BỎ</Button>, <Button key="submit" type="primary" style={{ backgroundColor: THEME_COLOR }}>CẬP NHẬT</Button>]}>
                    <div className="flex flex-col gap-4 py-2">
                        <FloatingLabelWrapper label="Tài sản" required><Input disabled value={getRecordName()} className="bg-gray-50" /></FloatingLabelWrapper>
                        <div className="grid grid-cols-2 gap-4">
                            <FloatingLabelWrapper label="Ngày báo" required><DatePicker className="w-full" format="DD/MM/YYYY" /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Giá trị"><Input /></FloatingLabelWrapper>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <FloatingLabelWrapper label="Số lượng" required><Input /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Tồn kho"><Input disabled value="Còn 1/1" className="bg-gray-50" /></FloatingLabelWrapper>
                        </div>
                        <FloatingLabelWrapper label="Mô tả"><TextArea rows={3} placeholder="Nhập mô tả" /></FloatingLabelWrapper>
                    </div>
                </Modal>

                {/* 5. Phiếu thanh lý */}
                <Modal title={<span className="font-bold text-000000e0">Phiếu thanh lý</span>} open={modals.liquidate} onCancel={() => closeModal('liquidate')} footer={[<Button key="back" onClick={() => closeModal('liquidate')}>HỦY BỎ</Button>, <Button key="submit" type="primary" style={{ backgroundColor: THEME_COLOR }}>CẬP NHẬT</Button>]}>
                    <div className="flex flex-col gap-4 py-2">
                        <FloatingLabelWrapper label="Tài sản" required><Input disabled value={getRecordName()} className="bg-gray-50" /></FloatingLabelWrapper>
                        <div className="grid grid-cols-3 gap-4">
                            <FloatingLabelWrapper label="Ngày thanh lý" required><DatePicker className="w-full" format="DD/MM/YYYY" /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Số lượng" required><Input /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Giá trị"><Input /></FloatingLabelWrapper>
                        </div>
                        <FloatingLabelWrapper label="Mô tả"><TextArea rows={3} placeholder="Nhập mô tả" /></FloatingLabelWrapper>
                    </div>
                </Modal>

                {/* 6. Cấp phát tài sản */}
                <Modal title={<span className="font-bold text-000000e0">Cấp phát tài sản</span>} open={modals.allocate} onCancel={() => closeModal('allocate')} footer={[<Button key="back" onClick={() => closeModal('allocate')}>HỦY BỎ</Button>, <Button key="submit" type="primary" style={{ backgroundColor: THEME_COLOR }}>CẬP NHẬT</Button>]}>
                    <div className="flex flex-col gap-4 py-2 max-h-[60vh] overflow-y-auto px-1 custom-scrollbar">
                        <div className="grid grid-cols-2 gap-4">
                            <FloatingLabelWrapper label="Mã CP" required><Input defaultValue="8889_116" /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Tài sản" required><Input disabled value={popup.record?.name} className="bg-gray-50" /></FloatingLabelWrapper>
                        </div>
                        <Checkbox className="text-gray-700">Phòng ban</Checkbox>
                        <FloatingLabelWrapper label="Nhân sự nhận" required><Select className="w-full" allowClear /></FloatingLabelWrapper>
                        <FloatingLabelWrapper label="Nguồn cấp phát"><Select className="w-full" allowClear defaultValue="HQ_495 - Mr. Huân" /></FloatingLabelWrapper>
                        <div className="grid grid-cols-2 gap-4">
                            <FloatingLabelWrapper label="Số lượng" required><Input /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Tồn kho"><Input disabled value="Còn 498 / 500" className="bg-gray-50" /></FloatingLabelWrapper>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <FloatingLabelWrapper label="Ngày cấp phát" required><DatePicker className="w-full" format="DD/MM/YYYY" /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Thời gian cấp phát" required><DatePicker picker="time" className="w-full" format="HH:mm" /></FloatingLabelWrapper>
                        </div>
                        <FloatingLabelWrapper label="Vị trí tài sản"><Select className="w-full" allowClear /></FloatingLabelWrapper>
                        <FloatingLabelWrapper label="Địa điểm bàn giao"><Input /></FloatingLabelWrapper>
                        <FloatingLabelWrapper label="Đặt cọc"><Input /></FloatingLabelWrapper>
                        <FloatingLabelWrapper label="Nhập dự kiến ngày trả"><DatePicker className="w-full" format="DD/MM/YYYY" /></FloatingLabelWrapper>
                        <FloatingLabelWrapper label="Lý do cấp phát"><TextArea rows={2} /></FloatingLabelWrapper>
                    </div>
                </Modal>

                {/* 7. Thu hồi tài sản */}
                <Modal title={<span className="font-bold text-000000e0">Thu hồi tài sản</span>} open={modals.recall} onCancel={() => closeModal('recall')} footer={[<Button key="back" onClick={() => closeModal('recall')}>HỦY BỎ</Button>, <Button key="submit" type="primary" style={{ backgroundColor: THEME_COLOR }}>CẬP NHẬT</Button>]}>
                    <div className="flex flex-col gap-4 py-2 max-h-[60vh] overflow-y-auto px-1 custom-scrollbar">
                        <div className="grid grid-cols-2 gap-4">
                            <FloatingLabelWrapper label="Mã thu hồi" required><Input defaultValue="BBTH.44" /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Tài sản"><Input disabled value={popup.record?.name} className="bg-gray-50" /></FloatingLabelWrapper>
                        </div>
                        <FloatingLabelWrapper label="Thu hồi cho lần cấp phát" required><Select className="w-full" allowClear /></FloatingLabelWrapper>
                        <div className="grid grid-cols-2 gap-4">
                            <FloatingLabelWrapper label="Nhập số lượng thu hồi" required><Input /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Cấp phát / Tổng"><Input disabled className="bg-gray-50" /></FloatingLabelWrapper>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <FloatingLabelWrapper label="Trạng thái"><Select className="w-full" allowClear /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Người thu hồi" required><Select className="w-full" allowClear defaultValue="HQ_495 - Mr. Huân" /></FloatingLabelWrapper>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <FloatingLabelWrapper label="Ngày thu hồi" required><DatePicker className="w-full" format="DD/MM/YYYY" /></FloatingLabelWrapper>
                            <FloatingLabelWrapper label="Giờ trả" required><DatePicker picker="time" className="w-full" format="HH:mm" /></FloatingLabelWrapper>
                        </div>
                        <FloatingLabelWrapper label="Địa điểm thu hồi"><Input /></FloatingLabelWrapper>
                        <Checkbox className="text-gray-700 mt-2">Trừ đặt cọc</Checkbox>
                        <FloatingLabelWrapper label="Lý do thu hồi"><TextArea rows={2} /></FloatingLabelWrapper>
                    </div>
                </Modal>

                {/* 8. In Qrcode */}
                <Modal title={<span className="font-bold text-000000e0">Danh sách mã Qrcode</span>} open={modals.qr} onCancel={() => closeModal('qr')} footer={null}>
                    <div className="flex flex-col items-center justify-center py-6 gap-4">
                        <h2 className="text-2xl font-bold text-000000e0">{popup.record?.id || 'TS.---'}</h2>
                        <div className="w-48 h-48 border-4 border-gray-800 p-2 rounded-lg relative flex items-center justify-center bg-white shadow-sm">
                            <QrCode size={160} className="text-000000e0" strokeWidth={1.5} />
                        </div>
                        <p className="text-red-500 font-semibold text-[13px] mt-4 text-center">
                            Chú ý: Ấn Ctrl + P để bắt đầu in mã Qrcode - (Tối đa in 32 mã cùng 1 lúc)
                        </p>
                    </div>
                </Modal>

                {/* CSS CUSTOM CHO MENU */}
                <style dangerouslySetInnerHTML={{
                    __html: `
                    /* Scrollbars */
                    .no-scrollbar::-webkit-scrollbar { display: none; }
                    .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
                    .custom-scrollbar::-webkit-scrollbar { width: 6px; height: 6px; }
                    .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                    .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 6px; }
                    .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
                    
                    /* Tùy chỉnh Menu Dropdown */
                    .custom-context-menu .ant-dropdown-menu {
                        padding: 8px 0;
                    }

                    .custom-context-menu .ant-dropdown-menu-item, 
                    .custom-context-menu .ant-dropdown-menu-submenu-title {
                        padding: 12px 16px !important; 
                        font-size: 13.5px !important;
                        color: #374151 !important;
                        display: flex !important;
                        align-items: center !important; 
                    }

                    .custom-context-menu .ant-dropdown-menu-item .anticon,
                    .custom-context-menu .ant-dropdown-menu-submenu-title .anticon,
                    .custom-context-menu .ant-dropdown-menu-item > svg,
                    .custom-context-menu .ant-dropdown-menu-submenu-title > svg {
                        display: flex !important;
                        align-items: center !important;
                        margin-top: 0 !important;
                    }

                    .custom-context-menu .ant-dropdown-menu-title-content {
                        display: flex !important;
                        align-items: center !important;
                        line-height: 1 !important;
                        margin-top: 1px !important; 
                    }

                    .custom-context-menu .ant-dropdown-menu-item:hover, 
                    .custom-context-menu .ant-dropdown-menu-submenu-title:hover {
                        background-color: #f3f4f6 !important;
                    }

                    .custom-context-menu .ant-dropdown-menu-item-divider {
                        margin: 4px 0 !important;
                    }
                    .dark .custom-context-menu .ant-dropdown-menu-item, .dark .custom-context-menu .ant-dropdown-menu-submenu-title {
                        color: #f3f4f6 !important;
                    }
                    .dark .custom-context-menu .ant-dropdown-menu-item:hover, .dark .custom-context-menu .ant-dropdown-menu-submenu-title:hover {
                        color: #374151 !important;
                    }
                `}} />

            </div>
        </Layout>
    );
};